export default __webpack_public_path__ + "assets/audio/1-50187558_clip.mp3";